<div class="bg-card rounded-2xl p-3">
  <div class="flex justify-center mb-8 px-4 mt-8">
    <div class="w-full sm:w-auto overflow-x-auto">
      <p-selectButton
        [options]="billingOptions"
        [(ngModel)]="selectedDuration"
        optionLabel="label"
        optionValue="value"
        class="w-full"
      >
      </p-selectButton>
    </div>
  </div>
  <div class="flex flex-col p-2 gap-4 rounded-md">
    <div class="flex flex-wrap justify-center gap-6 p-4">
      <div
        *ngFor="let plan of plans"
        class="bg-card rounded-xl border p-6 shadow-md hover:shadow-lg transition w-full max-w-[320px] flex flex-col"
        [ngStyle]="{ 'border-top': '4px solid ' + plan.plan_color }"
        
      >
        <!-- Plan Title -->
        <h3 class="text-xl font-semibold mb-2" [style.color]="plan.plan_color">
          {{ plan.name }}
        </h3>

        <p class="text-foreground text-sm mb-8 h-24">
          {{ plan.description }}
        </p>

        <!-- Pricing Toggle -->
        <!-- <div *ngIf="plan.pricing_tiers?.length" class="flex flex-wrap gap-2 justify-center mb-4">
          <button
            *ngFor="let tier of sortedPricingTiers(plan)"
            (click)="selectDuration(plan.id, tier.duration)"
            class="px-3 py-1 text-xs rounded-full border transition"
            [ngClass]="{
              'bg-primary text-white border-primary': selectedDuration[plan.id] === tier.duration,
              'bg-white text-gray-600 border-gray-300': selectedDuration[plan.id] !== tier.duration,
            }"
          >
            {{ pricingTierMap[tier.duration] }}
          </button>
        </div> -->

        <!-- Selected Price -->
        <div *ngIf="getSelectedTier(plan)" class="text-center mb-4">
          <span class="text-3xl font-bold">
            {{ getSelectedTier(plan)?.price | currency: 'INR' }}
          </span>
          <div class="text-sm text-foreground-tertiary">
            / {{ pricingTierMap[selectedDuration] }}
          </div>
        </div>

        <div
          *ngIf="!getSelectedTier(plan) && plan.pricing_tiers?.length"
          class="text-center text-gray-400 text-sm mb-4"
        >
          Not available
        </div>

        <div
          *ngIf="!plan.pricing_tiers?.length"
          class="text-center text-green-600 text-3xl font-bold mb-4"
        >
          Free
        </div>

        <!-- Pay Button -->
        <button
          class="w-full bg-primary text-white py-2 rounded-md font-semibold hover:opacity-90"
          (click)="payPlan(plan)"
        >
          Pay This Plan
        </button>

        <div class="border-b my-4"></div>

        <p class="text-sm font-semibold mb-3">What you get</p>

        <!-- Features -->
        <!-- <ul class="flex flex-col gap-4 text-sm border p-4 rounded-xl bg-card-contrast">
          <li *ngFor="let group of plan.features">
            <span class="font-semibold">{{ group.feature_category_name }}</span>
            <ul class="mt-1 flex flex-col gap-1">
              <li *ngFor="let item of group.features" class="flex items-center gap-2">
                <i class="pi pi-check text-primary"></i>
                {{ item.name }}
              </li>
            </ul>
          </li>
        </ul> -->
        <ul
          class="flex flex-col gap-4 text-sm border border-primary rounded-3xl bg-primary-50 max-h-80 overflow-y-auto"
        >
          <li *ngFor="let group of plan.features">
            <!-- Category Header -->
            <div
              class="font-semibold text-primary text-center text-sm sticky top-0 bg-primary-100 w-full py-2 px-2"
            >
              {{ group.feature_category_name }}
            </div>

            <!-- Features -->
            <ul class="mt-1 flex flex-col gap-1 p-3">
              <li *ngFor="let item of group.features" class="flex items-center gap-2">
                <span class="flex items-center justify-center">
                  <i class="pi pi-check text-primary"></i>
                </span>
                {{ item.name }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
